import fetchWrapper from "@/api/fetch-wrapper";

export const checkPassport = (form) => {
    const query = `ajax/checkPassport.php`;
    return fetchWrapper.post(query, form);
}